export default __webpack_public_path__ + "34ffa639439506da0acd202ecc967612.jpg";